<template>
	<div class="action-button-wrapper start">
	    <b-button size="sm" variant="link" :href="site.URL" target="_blank" class="site-action-btn">
	        <span class="icon-cont">
	            <eye-icon class="icon-default eye-icon"></eye-icon>
	        </span>
	        <span>View site</span>
	    </b-button>
	</div>
</template>

<script>
import EyeIcon from '../../assets/eye.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	EyeIcon
  },
  data() {
    return {
    };
  },
};
</script>